var React = require('react');

function ScrollDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.02,0V22.63","style":{"fill":"none","stroke":"#00ffa8","strokeWidth":"2px"},"key":0}),React.createElement("path",{"d":"M23.33,11.31l-11.31,11.31L.71,11.31","style":{"fill":"none","stroke":"#00ffa8","strokeWidth":"2px"},"key":1})]);
}

ScrollDown.defaultProps = {"id":"uuid-9e85eb88-d33c-427f-a723-77c1bda15aeb","viewBox":"0 0 24.04 24.04"};

module.exports = ScrollDown;

ScrollDown.default = ScrollDown;
